/* Nikura new mobile menu GA4 events (mobile_nav_wholesale_click, mobile_nav_tab_click,
   mobile_nav_category_click) on the standard reusable fields: location_id, click_text,
   link_url, section, element_position. A tile label that opens/closes its sub-list sends
   mobile_nav_category_expand on the sheet's own fields (row 9, 2026-10-15): location_id,
   active_tab, category_name, action, tile_position, grid_row, grid_column; a tap on a
   sub-list item sends mobile_nav_subcategory_click. Strict no-op on pages without .new-mobile-nav; the
   menu ships hidden on the live theme until the Convert experiment reveals it. */
(function () {
  if (window.__nkMobileNavEvents) return;
  window.__nkMobileNavEvents = true;

  function clean(s) { return (s || '').replace(/\s+/g, ' ').trim(); }
  function linkPath(href) {
    if (!href) return '';
    try {
      var u = new URL(href, location.origin);
      return u.origin === location.origin ? u.pathname + u.search : u.href;
    } catch (e) { return href; }
  }
  function push(o) {
    o.location_id = 'mobile_nav';
    (window.dataLayer = window.dataLayer || []).push(o);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var nav = t.closest('.new-mobile-nav');
    if (!nav) return;

    var cta = t.closest('.new-mobile-nav__top-content a.cta');
    if (cta) {
      push({ event: 'mobile_nav_wholesale_click', click_text: clean(cta.textContent), link_url: linkPath(cta.getAttribute('href')) });
      return;
    }

    var tab = t.closest('.new-mobile-nav__tab-btn');
    if (tab) {
      var tabs = Array.prototype.slice.call(nav.querySelectorAll('.new-mobile-nav__tab-btn'));
      push({ event: 'mobile_nav_tab_click', click_text: clean(tab.textContent), element_position: tabs.indexOf(tab) + 1 });
      return;
    }

    var card = t.closest('.new-mobile-nav__card');
    if (!card) return;
    var title = card.querySelector('.new-mobile-nav__card-title');
    if (!title) return;
    var cards = Array.prototype.slice.call(card.parentElement.children).filter(function (c) {
      return c.classList && c.classList.contains('new-mobile-nav__card');
    });
    var pos = cards.indexOf(card) + 1;
    var active = nav.querySelector('.new-mobile-nav__tab-btn--active');
    var tabName = active ? clean(active.textContent) : '';
    var category = clean(title.textContent);

    var subLink = t.closest('a.new-mobile-nav__sub-link');
    if (subLink) {
      var badge = subLink.querySelector('.new-mobile-nav__sub-link-badge');
      var items = Array.prototype.slice.call(card.querySelectorAll('a.new-mobile-nav__sub-link'));
      var text = clean(subLink.textContent);
      if (badge) text = clean(text.slice(0, text.length - clean(badge.textContent).length));
      push({ event: 'mobile_nav_subcategory_click', active_tab: tabName, category_name: category,
             click_text: text, link_url: linkPath(subLink.getAttribute('href')),
             element_position: items.indexOf(subLink) + 1, tile_position: pos });
      return;
    }
    if (t.closest('.new-mobile-nav__sub-menu')) return;

    // Label (with chevron) that opens/closes the tile's sub-list in place. Capture phase runs
    // before the theme's toggle, so is-open still holds the state before this tap.
    var toggle = t.closest('.new-mobile-nav__card-info');
    if (toggle && toggle.tagName !== 'A' && card.querySelector('.new-mobile-nav__sub-menu')) {
      var cols = 2;
      try {
        var tracks = getComputedStyle(card.parentElement).gridTemplateColumns.split(' ').filter(Boolean).length;
        if (tracks > 0) cols = tracks;
      } catch (err) {}
      push({ event: 'mobile_nav_category_expand', active_tab: tabName, category_name: category,
             action: toggle.classList.contains('is-open') ? 'collapse' : 'expand', tile_position: pos,
             grid_row: Math.floor((pos - 1) / cols) + 1, grid_column: ((pos - 1) % cols) + 1 });
      return;
    }

    var link = card.querySelector('a.new-mobile-nav__card-info');
    push({
      event: 'mobile_nav_category_click',
      click_text: category,
      section: tabName,
      link_url: link ? linkPath(link.getAttribute('href')) : '',
      element_position: pos
    });
  }, true);
})();
